import { render, staticRenderFns } from "./DetailProduk.vue?vue&type=template&id=2b5a40ec&"
import script from "./DetailProduk.vue?vue&type=script&lang=js&"
export * from "./DetailProduk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports